import { UniWealthCompliance } from '../BottomSheetComponents/mf-execution/UniWealthCompliance'
import RenderHTML from '../ui-components/RenderHTML'
import { useBottomSheet } from '../../state-management/contexts/BottomSheetContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMetaDataContext } from '../../state-management/contexts/MetaDataContext'
import { EventNames } from '../../types/misc.types'
import { goBack, trackEvent } from '../../utils/appBridge'

export const PaymentPageHeader = () => {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const { data, isin } = useMetaDataContext()
  const fundName = data?.fundDetails?.fundName ?? ''
  const fundTrack = isin && fundName ? { fundIsin: isin, fundName } : {}
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  return (
    <div className='pb-4 flex justify-between items-center w-full'>
      <div className='flex flex-col max-w-[80%]'>
        <div className='text-[#232323] text-[14px] font-[400] text-ellipsis overflow-hidden whitespace-nowrap leading-[110%]'>
          {data?.fundDetails?.fundName}
        </div>
        <div className='hidden text-[12px] text-[#8E9393] font-[400] flex gap-1 items-center'>
          <div> Via Uniorbit Wealth EOP </div>{' '}
          <div
            className='cursor-pointer'
            onClick={() =>
              openBottomSheet(<UniWealthCompliance onDismiss={closeBottomSheet} ScreenName='MFPaymentPage' />)
            }
          >
            <RenderHTML innerHTMLText={InfoIcon} />
          </div>
        </div>
      </div>
      <div
        className='cursor-pointer scale-[110%]'
        onClick={() => {
          trackEvent({
            eventName: EventNames.ButtonTap,
            payload: {
              eventId: 'MFE_PAYMENT_PAGE_HEADER_CLOSE',
              buttonLabel: 'Close',
              ...fundTrack
            }
          })
          if (searchParams?.get('from') === 'APP') goBack()
          else navigate(-1)
        }}
      >
        <RenderHTML innerHTMLText={CloseIcon} />
      </div>
    </div>
  )
}

const CloseIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <circle cx="12" cy="12.5" r="12" fill="#F0F4F7"/>
  <path d="M16 8.5L8 16.5" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 8.5L16 16.5" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const InfoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
  <g clip-path="url(#clip0_37964_12911)">
    <path d="M5.5 1C7.24324 1 8.47003 1.44268 9.26367 2.23633C10.0573 3.02998 10.5 4.25676 10.5 6C10.5 7.74324 10.0573 8.97003 9.26367 9.76367C8.47003 10.5573 7.24324 11 5.5 11C3.75676 11 2.52998 10.5573 1.73633 9.76367C0.942682 8.97003 0.5 7.74324 0.5 6C0.5 4.25676 0.94268 3.02998 1.73633 2.23633C2.52998 1.44268 3.75676 1 5.5 1Z" stroke="#8E9393"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.38451 7.51821C4.12765 7.51821 3.91943 7.72131 3.91943 7.97185C3.91943 8.2224 4.12765 8.42549 4.38451 8.42549H6.61686C6.87371 8.42549 7.08193 8.2224 7.08193 7.97185C7.08193 7.72131 6.87371 7.51821 6.61686 7.51821H5.96576V5.43148C5.96576 5.18094 5.75754 4.97784 5.50068 4.97784H4.75657C4.49971 4.97784 4.29149 5.18094 4.29149 5.43148C4.29149 5.68202 4.49971 5.88512 4.75657 5.88512H5.03561V7.51821H4.38451ZM6.2448 3.61693C6.2448 4.01779 5.91164 4.34275 5.50068 4.34275C5.08972 4.34275 4.75657 4.01779 4.75657 3.61693C4.75657 3.21608 5.08972 2.89111 5.50068 2.89111C5.91164 2.89111 6.2448 3.21608 6.2448 3.61693Z" fill="#8E9393"/>
  </g>
  <defs>
    <clipPath id="clip0_37964_12911">
      <rect width="11" height="11" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
  </defs>
</svg>`
